<div class="login-shell" *ngIf="!isLoading">

  <!-- ── Centered login card ─────────────────────────────────────────────── -->
  <div class="login-card">
    <header class="login-card-head">
      <img *ngIf="schoolLogo" class="logoWrapperMain" [src]="schoolLogo" alt="School Logo">
      <h4>{{ schoolName || '' }}</h4>
      <!-- <h5 *ngIf="schoolCode">Code: {{ schoolCode }}</h5> -->
      <h5>{{ schoolLocation || '' }}</h5>
    </header>

    <div class="login-card-body">
      <div class="login-title">
        <h3>Login</h3>
        <p class="credentailMainTxt">Enter your credentials to access the portal</p>
      </div>

      <form class="example-form" (ngSubmit)="login()">
        <div class="form-row two-col">
          <div class="form-group">
            <input type="text" class="form-control" placeholder="Username"
                   [(ngModel)]="username" name="username" required />
            <small class="errorsmall" *ngIf="username == '' && isSubmitted">Username is required</small>
          </div>

          <div class="form-group">
            <input [type]="showPasswordVal ? 'text' : 'password'" class="form-control" placeholder="Password"
                   [(ngModel)]="password" name="password" required />
            <span class="password-toggle" (click)="showPassword()">
              <i [ngClass]="showPasswordVal ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
            </span>
            <small class="errorsmall" *ngIf="password == '' && isSubmitted">Password is required</small>
          </div>
        </div>

        <div class="form-actions">
          <button class="main-button lockBtnmain" type="submit">
            <img alt="" src="../../assets/lock-img1.webp"><span>Log in</span>
          </button>
          <a class="forgot-link" [routerLink]="['/forgot-password']">Forgot Password?</a>
        </div>
      </form>

      <!-- App download tabs (Parents / Staff / Transport) -->
      <div class="playStoreNavLink">
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <button class="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home"
                    type="button" role="tab" aria-controls="nav-home" aria-selected="true">Parents</button>
            <button class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile"
                    type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Staff</button>
            <button class="nav-link" id="nav-transport-tab" data-bs-toggle="tab" data-bs-target="#nav-transport"
                    type="button" role="tab" aria-controls="nav-transport" aria-selected="false">Transport</button>
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab" tabindex="0">
            <div class="playstoreDivFlex">
              <a target="_blank" href="https://play.google.com/store/apps/details?id=com.edship.nora">
                <img alt="" src="../../assets/playstore.webp"><span>Google Play</span>
              </a>
              <a target="_blank" href="https://apps.apple.com/in/app/nora-connect/id6752776346">
                <img alt="" src="../../assets/apple.webp"><span>App Store</span>
              </a>
            </div>
          </div>
          <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab" tabindex="0">
            <div class="playstoreDivFlex">
              <a target="_blank" href="https://play.google.com/store/apps/details?id=com.edship.edship_teacher">
                <img alt="" src="../../assets/playstore.webp"><span>Google Play</span>
              </a>
              <a target="_blank" href="https://apps.apple.com/in/app/nora-pulse/id6751803850">
                <img alt="" src="../../assets/apple.webp"><span>App Store</span>
              </a>
            </div>
          </div>
          <div class="tab-pane fade" id="nav-transport" role="tabpanel" aria-labelledby="nav-transport-tab" tabindex="0">
            <div class="playstoreDivFlex">
              <a target="_blank" href="https://play.google.com/store/apps/details?id=com.edship.noratransit&pcampaignid=web_share">
                <img alt="" src="../../assets/playstore.webp"><span>Google Play</span>
              </a>
              <a target="_blank" href="https://apps.apple.com/in/app/nora-transit/id6752957881">
                <img alt="" src="../../assets/apple.webp"><span>App Store</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- School code pill -->
      <div class="schoolcodeBorderMain">
        <div class="schoolCodeMain">School Code</div>
        <div>{{ schoolCode || 'Saps' }}</div>
      </div>

      <!-- Policy acceptance — pre-checked; unchecking disables the Log in button -->
      <label class="terms-agree">
        <input type="checkbox" [(ngModel)]="agreedToTerms" name="agreedToTermsLogin" />
        <span>I agree to the
          <a href="javascript:void(0)" (click)="openPolicy('terms')">Terms &amp; Conditions</a>,
          <a href="javascript:void(0)" (click)="openPolicy('privacy')">Privacy Policy</a>,
          <a href="javascript:void(0)" (click)="openPolicy('refund')">Refund Policy</a> &amp;
          <a href="javascript:void(0)" (click)="openPolicy('payment')">Payment Terms</a>.</span>
      </label>
      <small class="errorsmall terms-error" *ngIf="!agreedToTerms && isSubmitted">
        Please accept the Terms, Privacy, Refund &amp; Payment Policy to continue.
      </small>
    </div>

    <!-- ── Bottom row: two showcase action buttons ──────────────────────── -->
    <div class="showcase-actions">
      <button type="button" class="showcase-btn" (click)="openShowcase('product')">
        <i class="bi bi-grid-3x3-gap-fill"></i>
        Nora Product Suite
      </button>
      <button type="button" class="showcase-btn" (click)="openShowcase('school')">
        <i class="bi bi-mortarboard-fill"></i>
        School View
      </button>
    </div>
  </div>

  <!-- ── Footer (always visible at the bottom) ───────────────────────────── -->
  <footer class="login-footer">
    <span class="footer-powered">
      Powered By <a href="https://edship.in/" target="_blank" rel="noopener">EdShip Technologies Private Limited</a>
    </span>
    <a class="footer-link" href="https://edship.in" target="_blank" rel="noopener">www.edship.in</a>
    <!-- <a class="footer-link footer-terms-link" href="javascript:void(0)" (click)="openTerms()">Terms &amp; Conditions</a> -->
    <ul class="login-social">
      <li><a target="_blank" href="https://www.facebook.com/edshiptechnologies"><img alt="" src="../../assets/facebook.webp"></a></li>
      <li><a target="_blank" href="https://www.youtube.com/@edshiptechnologies"><img alt="" src="../../assets/youtube.webp"></a></li>
      <li><a target="_blank" href="https://www.instagram.com/edshiptechnologies/"><img alt="" src="../../assets/instagram.webp"></a></li>
      <li><a target="_blank" href="https://www.linkedin.com/company/edshiptechnologies"><img alt="" src="../../assets/linkedin.webp"></a></li>
    </ul>
  </footer>

  <!-- ── Showcase overlay: opens on action-button click ───────────────────── -->
  <div class="showcase-overlay" *ngIf="showcaseOpen" (click)="closeShowcase()">
    <div class="showcase-content" (click)="$event.stopPropagation()">
      <button class="showcase-close" type="button" (click)="closeShowcase()" aria-label="Close showcase">
        <i class="bi bi-x-lg"></i>
      </button>
      <div id="loginShowcaseCarousel" class="carousel slide carousel-fade"
           data-bs-ride="carousel" data-bs-interval="3500">
        <div class="carousel-inner">
          <div class="carousel-item" [class.active]="showcaseStart === 'product'">
            <img alt="" src="../../assets/background-new.webp">
          </div>
          <div class="carousel-item" [class.active]="showcaseStart === 'school'">
            <img alt="" [src]="schoolLogo || '../../assets/school-final.webp'">
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#loginShowcaseCarousel" data-bs-slide="prev">
          <span class="carousel-control-prev-icon"></span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#loginShowcaseCarousel" data-bs-slide="next">
          <span class="carousel-control-next-icon"></span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-loader [loading]="isLoading"></app-loader>

<!-- ── Terms & Conditions modal ─────────────────────────────────────────────── -->
<div class="terms-overlay" *ngIf="termsOpen" (click)="closeTerms()">
  <div class="terms-modal" role="dialog" aria-modal="true" aria-label="Terms and Conditions" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="terms-header">
      <div class="terms-header-inner">
        <div>
          <h2>{{ policyTab === 'privacy' ? 'Privacy Policy' : policyTab === 'refund' ? 'Refund & Cancellation Policy' : policyTab === 'payment' ? 'Payment Terms' : 'Terms & Conditions' }}</h2>
          <p>Edship Technologies Private Limited</p>
        </div>
      </div>
      <button class="terms-close" type="button" (click)="closeTerms()" aria-label="Close terms">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <!-- Policy tab strip -->
    <nav class="policy-tabs">
      <button type="button" class="policy-tab" [class.active]="policyTab==='terms'"   (click)="policyTab='terms'">Terms &amp; Conditions</button>
      <button type="button" class="policy-tab" [class.active]="policyTab==='privacy'" (click)="policyTab='privacy'">Privacy Policy</button>
      <button type="button" class="policy-tab" [class.active]="policyTab==='refund'"  (click)="policyTab='refund'">Refund &amp; Cancellation</button>
      <button type="button" class="policy-tab" [class.active]="policyTab==='payment'" (click)="policyTab='payment'">Payment Terms</button>
    </nav>

    <!-- Body -->
    <div class="terms-body">
     <div class="policy-pane" *ngIf="policyTab==='terms'">
      <p class="terms-intro">
        These Terms and Conditions ("Terms") govern your access to and use of Edship Technologies Private Limited's
        ("Edship", "we", "us", "our") products, services, and platforms — including <strong>Nora Pulse</strong>
        (School ERP), <strong>Nora Connect</strong> (Parent App), <strong>Nora Transit</strong> (Transport Management),
        <strong>Bueagle</strong> (IoT Fleet Tracking), <strong>Simi AI</strong> (AI Assistant), and <strong>Facy</strong>
        (Facial Recognition). By accessing or using any Edship product, you agree to these Terms.
      </p>

      <section class="terms-section">
        <h3><span class="terms-num">1</span>Acceptance of Terms</h3>
        <p>By accessing, registering for, or using any Edship service as a school administrator, teacher, parent, student, or partner, you confirm that you have read, understood, and agree to be bound by these Terms. If you are accepting these Terms on behalf of an institution or organization, you represent that you have the authority to bind that entity.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">2</span>Description of Services</h3>
        <p>Edship provides a suite of cloud-based and IoT-enabled educational technology solutions:</p>
        <ul>
          <li><strong>Nora Pulse</strong> (School ERP &amp; Administration) — student information system, fee management, timetabling, HR &amp; payroll, attendance, examinations, library management, and hostel management.</li>
          <li><strong>Nora Connect</strong> (Parent Engagement Platform) — real-time notifications, academic tracking, fee payments, direct messaging, and transport visibility.</li>
          <li><strong>Nora Transit</strong> (Transport Management System) — route management, driver allocation, vehicle compliance, and communication tools.</li>
          <li><strong>Bueagle</strong> (IoT Fleet Tracking) — GPS-based real-time vehicle tracking, geofencing, SOS alerts, AI route optimization, and driver behavior monitoring.</li>
          <li><strong>Simi</strong> (AI Assistant) — natural language queries for academic data, attendance, fee status, and administrative reports.</li>
          <li><strong>Facy</strong> (Facial Recognition Attendance) — biometric-based student and staff attendance using AI-powered facial recognition.</li>
          <li><strong>E-Store</strong> — online procurement platform for schools to manage vendor orders, inventory, and canteen supplies.</li>
        </ul>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">3</span>User Accounts &amp; Responsibilities</h3>
        <p>When creating an account, you agree to:</p>
        <ul>
          <li>Provide accurate, current, and complete information during registration.</li>
          <li>Maintain confidentiality of login credentials and not share them with unauthorized individuals.</li>
          <li>Notify Edship immediately of any unauthorized account use.</li>
          <li>Use services only for lawful educational and administrative purposes.</li>
          <li>Ensure all institutional users comply with these Terms.</li>
          <li>Not attempt to reverse-engineer, decompile, or tamper with Edship software or systems.</li>
        </ul>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">4</span>Subscription, Fees &amp; Payment</h3>
        <p>Edship services operate on a subscription basis. Pricing, billing cycles, and payment terms are outlined in your specific service agreement or order form. All fees are non-refundable unless explicitly stated otherwise. Edship reserves the right to modify pricing with 30 days' advance written notice. Late payments may result in temporary service suspension. Schools must ensure timely renewal to avoid data access interruptions.</p>
        <p>Online payments may include a non-refundable transaction or convenience fee borne by the payer. Transaction fees are not refunded or reversed under any circumstances, including refunds, reversals, or chargebacks. Refunds and cancellations are governed by the separate Refund &amp; Cancellation Policy. School and institutional fees are collected on behalf of the respective institution, with Edship facilitating the transaction only.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">5</span>Data Ownership &amp; Usage</h3>
        <p>All institutional data entered into Edship platforms — including student records, attendance data, fee transactions, and academic records — remains the property of the subscribing institution. Edship acts as a data processor and will not sell, share, or monetize institutional data. Aggregated, anonymized data may be used to improve products and services. Upon service termination, institutions may request data export within 90 days of the termination date.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">6</span>Data Export, Access Control &amp; Institutional Responsibility</h3>
        <p>The subscribing institution is the Data Fiduciary (controller) for all personal data processed through the platform, with Edship acting solely as a Data Processor on the institution's documented instructions. The institution is solely responsible for:</p>
        <ul>
          <li>Provisioning, configuring, and revoking user accounts and access roles, determining which administrators, staff, or users may view, generate reports from, export, or download data.</li>
          <li>Ensuring authorized users access and use data only for legitimate educational and administrative purposes, in compliance with the Digital Personal Data Protection Act, 2023 and applicable law.</li>
          <li>Security, storage, lawful handling, and onward use of any data once exported, downloaded, printed, or otherwise removed from the platform.</li>
        </ul>
        <p>Data that has been exported or downloaded from the platform leaves Edship's technical and security controls. Edship records export and download activity in audit logs for institutional investigation of suspected misuse; however, Edship does not control and is not responsible for subsequent handling, disclosure, or misuse of exported data by the institution or its authorized users. By using the platform, the institution and its users acknowledge and accept this allocation of responsibility.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">7</span>Audit, Security &amp; Activity Monitoring</h3>
        <p>To meet legal record-keeping obligations and protect platform security and integrity, Edship maintains audit and activity logs, including authentication records, records of access to and changes, exports, or deletions of personal data, and usage telemetry. Such processing is carried out in accordance with the Privacy Policy and the Digital Personal Data Protection Act, 2023. By using the platform you acknowledge that your activity within it is logged for these purposes.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">8</span>Acknowledgement of Policies</h3>
        <p>By registering for, accessing, or making a payment through any Edship service, you confirm that you have read and agree to these Terms &amp; Conditions, the Privacy Policy, the Refund &amp; Cancellation Policy, and the applicable Payment Terms, each of which is incorporated by reference.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">9</span>Intellectual Property</h3>
        <p>All content, features, functionality, software, designs, trademarks, and technology comprising Edship's products are owned by Edship Technologies Private Limited and protected by Indian and international intellectual property laws. You are granted a limited, non-exclusive, non-transferable license to use the services for their intended purpose during your active subscription period. You may not reproduce, distribute, modify, create derivative works, publicly display, or commercially exploit any Edship technology without prior written consent.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">10</span>Service Availability &amp; SLA</h3>
        <p>Edship strives to maintain 99.9% uptime for all cloud-based services. Scheduled maintenance windows will be communicated in advance. The company is not liable for service interruptions caused by factors beyond its control, including internet outages, natural disasters, government actions, or third-party service failures. For IoT and GPS-based services (Bueagle, Nora Transit), performance may vary based on hardware condition, network coverage, and environmental factors.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">11</span>Acceptable Use Policy</h3>
        <p>You agree not to use Edship services to:</p>
        <ul>
          <li>Upload or transmit harmful, offensive, or unlawful content.</li>
          <li>Interfere with or disrupt the integrity or performance of services.</li>
          <li>Attempt to gain unauthorized access to any Edship systems or other users' accounts.</li>
          <li>Use automated scripts, bots, or crawlers to access services without authorization.</li>
          <li>Export, download, copy, or extract personal or institutional data for purposes other than the institution's legitimate educational and administrative purposes.</li>
          <li>Sell, publish, share, or otherwise disclose exported data to any unauthorized third party, or use it for personal, commercial, or marketing purposes.</li>
          <li>Violate any applicable local, state, national, or international law or regulation.</li>
        </ul>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">12</span>Third-Party Integrations</h3>
        <p>Edship services may integrate with third-party services such as payment gateways, SMS providers, WhatsApp Business API, biometric hardware (eSSL), and mapping services. These integrations are subject to the respective third-party terms and privacy policies. Edship is not responsible for the availability, accuracy, or practices of third-party services.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">13</span>Limitation of Liability</h3>
        <p>To the fullest extent permitted by applicable law, Edship Technologies shall not be liable for any indirect, incidental, special, consequential, or punitive damages — including loss of profits, data, or business opportunities — resulting from the use or inability to use services. Edship shall not be liable for any loss, claim, or damage arising from the access, export, download, or use of data by the institution or its authorized users, or from the handling or misuse of data after it has been exported, downloaded, or otherwise removed from the platform, such matters being the institution's responsibility as Data Fiduciary. The company's total liability for any claim arising from or related to these Terms shall not exceed the amount paid by you to Edship in the twelve (12) months preceding the claim.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">14</span>Termination</h3>
        <p>Either party may terminate the service agreement with 30 days' written notice. Edship reserves the right to immediately suspend or terminate access if you violate these Terms, fail to make timely payments, or engage in activities that compromise the security or integrity of the company's systems. Upon termination, your right to access the services ceases immediately. Data retention and export provisions as described in Section 5 shall apply.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">15</span>Indemnification</h3>
        <p>You agree to indemnify and hold harmless Edship Technologies, its directors, employees, and partners from any claims, damages, losses, or expenses (including legal fees) arising from your use of the services, violation of these Terms, or infringement of any third-party rights — including any claim arising from the misuse, unauthorized disclosure, or unlawful processing of data by your administrators, staff, or other authorized users, or from data exported or downloaded from the platform.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">16</span>Governing Law &amp; Dispute Resolution</h3>
        <p>These Terms are governed by and construed in accordance with the laws of India, including the Digital Personal Data Protection Act, 2023 and the rules made thereunder, to the extent applicable to the processing of personal data under these Terms. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts in Ernakulam, Kerala, India. Before initiating any legal proceedings, both parties agree to attempt resolution through good-faith negotiation and mediation.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">17</span>Modifications to Terms</h3>
        <p>Edship reserves the right to update or modify these Terms at any time. Material changes will be communicated via email or in-app notification at least 15 days prior to taking effect. Continued use of the services after such changes constitutes acceptance of the revised Terms.</p>
      </section>

      <section class="terms-section terms-contact">
        <h3><span class="terms-num">18</span>Contact Us</h3>
        <address>
          <strong>Edship Technologies Private Limited</strong><br>
          BB Arcade, Near Infopark Phase1, Edachira-Millumpady Road,<br>
          Kochi, Kerala 682042<br><br>
          <span><i class="bi bi-envelope-fill"></i>
            <a href="mailto:info@edship.in">info@edship.in</a>
          </span><br>
          <span><i class="bi bi-telephone-fill"></i>
            <a href="tel:+916238506588">+91 623 850 6588</a>
          </span>
        </address>
      </section>
     </div>

    <!-- Privacy Policy pane -->
    <div class="policy-pane" *ngIf="policyTab==='privacy'">
      <p class="terms-intro">This Privacy Policy describes how Edship Technologies Private Limited collects, uses, and protects personal data across its platforms. The full policy is available at <a href="https://edship.in/privacy/" target="_blank" rel="noopener">edship.in/privacy</a>.</p>

      <section class="terms-section">
        <h3><span class="terms-num">1</span>Information We Collect</h3>
        <h4>a) Information Provided by Institutions</h4>
        <ul>
          <li>Student details: name, date of birth, class, section, roll number, parent/guardian contact information, address, photograph, medical information (if provided).</li>
          <li>Staff details: name, employee ID, designation, contact details, qualification, salary information.</li>
          <li>Institutional details: school name, affiliation number, address, management details.</li>
        </ul>
        <h4>b) Information Collected Automatically</h4>
        <ul>
          <li>Device information: device type, operating system, browser type, IP address.</li>
          <li>Usage data: pages visited, features used, session duration, interaction patterns.</li>
          <li>Location data: GPS coordinates from IoT devices and mobile apps (with explicit consent).</li>
          <li>Biometric data: facial recognition templates for attendance stored as encrypted mathematical representations.</li>
        </ul>
        <h4>c) Information from Third Parties</h4>
        <p>Payment gateways, SMS/WhatsApp providers, and biometric hardware partners may provide transaction status, delivery reports, and device health data.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">2</span>How We Use Your Information</h3>
        <ul>
          <li>Providing and maintaining educational technology services.</li>
          <li>Processing fee payments, generating invoices, and financial reporting.</li>
          <li>Sending notifications about attendance, grades, transport updates, and school events.</li>
          <li>Enabling real-time GPS tracking and geofencing alerts for student transport safety.</li>
          <li>Processing facial recognition for touchless attendance marking.</li>
          <li>Powering AI-driven features like Simi chatbot responses and predictive analytics.</li>
          <li>Improving product quality through anonymized usage analytics.</li>
          <li>Communicating service updates, security alerts, and support responses.</li>
          <li>Complying with legal obligations and regulatory requirements.</li>
        </ul>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">3</span>Student Data Protection</h3>
        <ul>
          <li>Student data is never used for advertising, marketing, or profiling purposes.</li>
          <li>Data is never sold, rented, or traded to any third party.</li>
          <li>Access is strictly role-based; teachers see only their class data, parents see only their child's data.</li>
          <li>Access is provisioned and controlled by the subscribing institution.</li>
          <li>Student biometric data (facial templates) is encrypted using AES-256 and stored separately from personal identifiers.</li>
          <li>All student data processing complies with the Digital Personal Data Protection Act, 2023 (DPDPA) and applicable Indian law.</li>
          <li>Parents/guardians retain the right to access, correct, or request deletion of their child's data.</li>
        </ul>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">4</span>Data Security</h3>
        <ul>
          <li><strong>Encryption:</strong> All data is encrypted in transit (TLS 1.3) and at rest (AES-256).</li>
          <li><strong>Access Control:</strong> Role-based access control (RBAC) with multi-factor authentication for administrative accounts.</li>
          <li><strong>Infrastructure:</strong> Hosted on enterprise-grade cloud infrastructure with ISO 27001 compliance.</li>
          <li><strong>Monitoring:</strong> 24/7 security monitoring, intrusion detection, and automated threat response.</li>
          <li><strong>Backups:</strong> Regular automated backups with geographic redundancy and disaster recovery protocols.</li>
          <li><strong>Auditing:</strong> Comprehensive audit logs for all data access and modifications.</li>
        </ul>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">5</span>Audit Logging, Activity Monitoring &amp; Governance</h3>
        <p>Edship maintains governance and audit records of activity on its systems:</p>
        <ul>
          <li><strong>Authentication events:</strong> successful and failed logins, logout, token refresh, lockouts, and password changes with date/time, IP address, device/browser (user-agent), and access channel.</li>
          <li><strong>Data-access and change activity:</strong> which user accessed, created, modified, exported, deleted, or viewed a personal-data record through which module; sensitive field values are masked in logs.</li>
          <li><strong>Page-view / usage telemetry:</strong> pages or screens navigated within web and mobile applications; query parameters are stripped before storage.</li>
          <li><strong>Database/schema-integrity events:</strong> automated anomaly alerts for off-hours access, bulk export or deletion, repeated failed logins, or cross-account access.</li>
        </ul>
        <p>Access to governance records is restricted to authorized administrators.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">6</span>Lawful Basis &amp; Purpose of Audit Processing</h3>
        <p>Audit data is processed on the basis of:</p>
        <ul>
          <li><strong>Legal obligation:</strong> to maintain demonstrable accountability and records under DPDPA and applicable law.</li>
          <li><strong>Legitimate interests:</strong> to secure the platform, prevent and investigate fraud, misuse, and data breaches, and operate the service reliably.</li>
        </ul>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">7</span>Data Sharing &amp; Disclosure</h3>
        <p>Data is not sold. Sharing occurs only in these limited circumstances:</p>
        <ul>
          <li>With service providers (payment gateways, SMS/email providers, cloud hosting) under strict contractual obligations.</li>
          <li>With the subscribing institution.</li>
          <li>When required by law, regulation, legal process, or enforceable government request.</li>
          <li>To protect the rights, safety, or property of Edship, its users, or the public.</li>
        </ul>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">8</span>Location &amp; IoT Data</h3>
        <p>Transport and fleet management services (Bueagle, Nora Transit) collect real-time GPS data from IoT devices for student safety — tracking vehicle locations, triggering geofence alerts, and optimizing routes. Location data is retained for 90 days for operational purposes then archived. Parents can view their child's transport location only during active trip hours.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">9</span>Cookies &amp; Analytics</h3>
        <p>Websites and web applications use essential cookies for authentication, session management, and security. Analytics tools understand usage patterns and improve services. Cookies are not used for advertising or cross-site tracking. Users can manage cookie preferences through browser settings.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">10</span>Data Retention</h3>
        <ul>
          <li>Institutional data is retained for the duration of active service agreements plus a 90-day grace period, then securely deleted unless extension or export is requested.</li>
          <li>Student academic records may be retained longer if required by educational regulations.</li>
          <li>Biometric templates are deleted within 30 days of student de-enrollment or upon institutional request.</li>
          <li>Governance and audit logs are retained approximately three (3) months in active storage and up to twelve (12) months in compressed archive, then permanently purged.</li>
          <li>Page-view/usage telemetry is retained approximately sixty (60) days then permanently deleted.</li>
        </ul>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">11</span>Your Rights as a Data Principal (DPDPA 2023)</h3>
        <p>Under the Digital Personal Data Protection Act, 2023:</p>
        <ul>
          <li><strong>Right to Access:</strong> Obtain a summary of personal data held and processing activities.</li>
          <li><strong>Right to Correction, Completion &amp; Updating:</strong> Request correction of inaccurate or misleading data, and completion or updating of incomplete data.</li>
          <li><strong>Right to Erasure:</strong> Request deletion of personal data no longer necessary for its original purpose (subject to legal and contractual obligations).</li>
          <li><strong>Right to Withdraw Consent:</strong> Withdraw consent at any time where processing is consent-based, as easily as it was given.</li>
          <li><strong>Right to Grievance Redressal:</strong> Raise a grievance about personal data handling.</li>
          <li><strong>Right to Nominate:</strong> Nominate another individual to exercise rights in event of death or incapacity.</li>
          <li><strong>Right to Data Portability:</strong> Request data in a structured, commonly used format.</li>
        </ul>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">12</span>Children's Privacy</h3>
        <p>Services are designed for institutional use and not directed at children under 13 without institutional and parental oversight. Student data is collected only through authorized institutional channels with appropriate consent. If personal data from a child is collected without proper authorization, immediate deletion steps will be taken.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">13</span>Changes to This Policy</h3>
        <p>The Privacy Policy may be updated periodically to reflect changes in practices, technologies, or legal requirements. Material changes will be communicated via email to institutional administrators and through in-app banners at least 15 days before taking effect.</p>
      </section>

      <section class="terms-section terms-contact">
        <h3><span class="terms-num">14</span>Grievance Redressal &amp; Data Protection Contact</h3>
        <address>
          <strong>Edship Technologies Private Limited</strong><br>
          BB Arcade, Near Infopark Phase1, Edachira-Millumpady Road,<br>
          Kochi, Kerala 682042<br><br>
          <span><i class="bi bi-envelope-fill"></i>
            <a href="mailto:info@edship.in">info&#64;edship.in</a>
          </span><br>
          <span><i class="bi bi-telephone-fill"></i>
            <a href="tel:+916238506588">+91 623 850 6588</a>
          </span>
        </address>
        <p>Grievances and rights requests will be acknowledged and responded to within timelines prescribed under DPDPA and applicable rules.</p>
      </section>
    </div>

    <!-- Refund & Cancellation pane -->
    <div class="policy-pane" *ngIf="policyTab==='refund'">
      <p class="terms-intro">Refund &amp; Cancellation Policy — Edship Technologies Private Limited.</p>

      <section class="terms-section">
        <h3><span class="terms-num">1</span>Subscription &amp; Service Fees</h3>
        <p>Subscription and service fees paid to Edship Technologies Private Limited are non-refundable for any reason or under any clause, except where a refund is expressly required by applicable law or has been explicitly agreed by Edship in writing.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">2</span>Transaction / Payment-Gateway Fees</h3>
        <div class="policy-notice-box">
          <div class="policy-notice-title"><i class="bi bi-exclamation-triangle-fill"></i> Important Notice</div>
          <ul class="policy-notice-list">
            <li>Transaction fee charges will <strong>not be refunded or reversed under any circumstances</strong> — for any refund, reversal, chargeback, or any other reason.</li>
            <li>Transaction fees charged are <strong>borne by the cardholder / account holder (owner)</strong> for any payment.</li>
            <li>Fees once paid are <strong>non-refundable</strong> for any reason or under any clause.</li>
          </ul>
        </div>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">3</span>School / Institutional Fee Payments</h3>
        <p>Payments toward school fees are collected on behalf of institutions. Eligibility for any refund of the underlying fee (excluding transaction / convenience fees, which are never refundable) is governed solely by that institution's policy. Edship acts as a transaction facilitator only and bears no responsibility for institutional fee refunds.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">4</span>Cancellations</h3>
        <p>A payment that has been successfully authorised and captured cannot be cancelled through the platform. For permitted cancellations, users must contact the institution directly. Any platform-side reversal, where applicable, excludes the non-refundable transaction fee.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">5</span>Chargebacks</h3>
        <p>In the event of a chargeback or dispute, the transaction fee remains non-refundable and is borne by the payer. The company reserves the right to recover associated costs from payment gateways or banks.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">6</span>Failed / Duplicate Transactions</h3>
        <p>For failed payments with debits or verified duplicates, the principal amount (excluding the non-refundable transaction fee, where a fee was levied on a successful leg) is reversed to the original payment instrument within standard settlement timelines of 5–7 business days.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">7</span>Method of Refund</h3>
        <p>Approved refunds go exclusively to the original payment instrument used. Cash refunds or alternate account transfers are unavailable.</p>
      </section>

      <section class="terms-section terms-contact">
        <h3><span class="terms-num">8</span>Grievance &amp; Refund Queries</h3>
        <address>
          <strong>Edship Technologies Private Limited</strong><br><br>
          <span><i class="bi bi-envelope-fill"></i>
            <a href="mailto:info@edship.in">info&#64;edship.in</a>
          </span><br>
          <span><i class="bi bi-telephone-fill"></i>
            <a href="tel:+916238506588">+91 623 850 6588</a>
          </span>
        </address>
      </section>
    </div>

    <!-- Payment Terms pane -->
    <div class="policy-pane" *ngIf="policyTab==='payment'">
      <p class="terms-intro">Payment Terms — applicable to online payments made through Edship platforms. These clauses are drawn from Terms &amp; Conditions §4, Refund Policy §2 and §5, and apply to all transactions processed through the platform.</p>

      <div class="policy-notice-box">
        <div class="policy-notice-title"><i class="bi bi-exclamation-triangle-fill"></i> Important Payment &amp; Refund Notice</div>
        <ul class="policy-notice-list">
          <li>Transaction fee charges will <strong>not be refunded / reversed under any circumstances</strong> for any refund / reversal / chargeback and any other reasons.</li>
          <li>Transaction fees charged are <strong>borne by the cardholder / account holder (owner)</strong> for any payment.</li>
          <li>Fees once paid are <strong>non-refundable</strong> for any reason or any clause.</li>
        </ul>
      </div>

      <section class="terms-section">
        <h3><span class="terms-num">1</span>Subscription, Fees &amp; Payment (Terms §4)</h3>
        <p>Edship services operate on a subscription basis. Pricing, billing cycles, and payment terms are outlined in your specific service agreement or order form. All fees are non-refundable unless explicitly stated otherwise. Edship reserves the right to modify pricing with 30 days' advance written notice. Late payments may result in temporary service suspension. Schools must ensure timely renewal to avoid data access interruptions.</p>
        <p>Online payments may include a non-refundable transaction or convenience fee borne by the payer. Transaction fees are not refunded or reversed under any circumstances, including refunds, reversals, or chargebacks. School and institutional fees are collected on behalf of the respective institution, with Edship facilitating the transaction only.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">2</span>Transaction / Payment-Gateway Fees (Refund Policy §2)</h3>
        <ul>
          <li>Transaction fee charges will not be refunded or reversed under any circumstances — for any refund, reversal, chargeback, or any other reason.</li>
          <li>Transaction fees charged are borne by the cardholder / account holder (owner) for any payment.</li>
          <li>Fees once paid are non-refundable for any reason or under any clause.</li>
        </ul>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">3</span>Authorisation &amp; Cancellations</h3>
        <p>Payments, once authorised and captured, cannot be cancelled through the platform. For permitted cancellations, users must contact the institution directly. Any platform-side reversal, where applicable, excludes the non-refundable transaction fee.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">4</span>Chargebacks (Refund Policy §5)</h3>
        <p>In the event of a chargeback or dispute, the transaction fee remains non-refundable and is borne by the payer. The company reserves the right to recover associated costs from payment gateways or banks.</p>
      </section>

      <section class="terms-section">
        <h3><span class="terms-num">5</span>Institutional / School Fee Payments</h3>
        <p>School fees are collected on behalf of the institution. Eligibility for any refund of the underlying fee (excluding transaction / convenience fees, which are never refundable) is governed solely by that institution's policy. Edship facilitates the transaction only and bears no responsibility for institutional fee refunds.</p>
      </section>

      <section class="terms-section terms-contact">
        <h3><span class="terms-num">6</span>Payment Queries</h3>
        <p>For payment-related queries, please contact:</p>
        <address>
          <strong>Edship Technologies Private Limited</strong><br><br>
          <span><i class="bi bi-envelope-fill"></i>
            <a href="mailto:info@edship.in">info&#64;edship.in</a>
          </span><br>
          <span><i class="bi bi-telephone-fill"></i>
            <a href="tel:+916238506588">+91 623 850 6588</a>
          </span>
        </address>
      </section>
    </div>
    </div>

    <!-- Footer -->
    <div class="terms-footer">
      <label class="terms-footer-agree">
        <input type="checkbox" [(ngModel)]="agreedToTerms" name="agreedToTermsModal" />
        <span>I agree to the Terms &amp; Conditions and the Payment &amp; Refund Policy</span>
      </label>
      <div class="terms-footer-actions">
        <span class="terms-effective">Last updated: 1st April 2026</span>
        <button class="terms-accept-btn" type="button" [disabled]="!agreedToTerms" (click)="closeTerms()">
          <i class="bi bi-check-circle-fill"></i> I Understand &amp; Accept
        </button>
      </div>
    </div>
  </div>
</div>
